import React, { FC } from 'react'
import { Button, Card, Col, Row, Form } from 'react-bootstrap'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Formik } from 'formik'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { CreateAccountSchema } from '../../../utils/validation'
import { mainColors } from '../../../assets/colors'
import './index.css'

interface Props {
  creatingUser: boolean;
  duplicateEmail: boolean;
  emailSent: boolean;
  error: any;
  errorType: string;
  showError: boolean;
  onBack: () => void;
  onSubmit: (e: any) => void;
}

const CreateAccount: FC<Props> = ({ creatingUser, duplicateEmail, emailSent, error, errorType, showError, onBack, onSubmit }: Props) => {
  const loginError = showError ? (
    <div className="loading-error-msg-2">
      <FontAwesomeIcon icon={['fas', 'exclamation-circle']} className="login-error-icon" size="3x"/>
      <div style={error.response ? { width: '23rem', height: '3rem' } : {} }>
        <span className="loading-error-msg-span">{errorType === 'validate' ? 'The email could not be verified.' : errorType === 'mail' ? 'Email to verify account could not be sent.' : 'The account could not be created.'}</span>
      </div>
    </div>
  ) : <div></div>

  const warningMessage = !emailSent ? (
    <div className="login-warning-msg">
      <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} className="login-warning-icon" color={'orange'} size="2x"/>
      <div>
        <span className="loading-error-msg-span" style={{margin: 0}}>You are applying to be a contracted provider, if your organization is already contracted please contact your organization administrator to access your Provider Portal.</span>
      </div>
    </div>
  ) : null

  const errorMessage = !duplicateEmail ? null : (
    <Form.Text className="provider-admin-error-msg">
      <FontAwesomeIcon icon={['fas', 'exclamation-circle']} className="login-error-icon"/> Email address already in use.
    </Form.Text>
  )

  const createAccountMsg = emailSent ? (
    <div className="success-container">
      <FontAwesomeIcon icon={['far', 'check-circle']} color={mainColors.successGreen} className="modal-success-icon" />
      <span className='success-text'>Success! Your account has been created. </span>
      <span className='login-forgot-text'>A link to activate your account has been sent to your email address.</span>
    </div>
  ) : null
  
  return (
	
    <Card className="login-card">
      <Card.Body className="login-card-body">
        {
          creatingUser ? (
            <div className="login-loading-container">
              <CircularProgress size={70} />
              <span className="login-loading-text">Saving data</span>
            </div>
          ) : (
            <>
              <span className='create-application-text'>Apply to be a contracted provider</span>
              {createAccountMsg}
              {loginError}
              {emailSent===false ?(
                <Formik
                  initialValues={{
                    firstName: null,
                    lastName: null,
                    email: null
                  }}
                  enableReinitialize
                  onSubmit={(values, { setSubmitting }) => {
                    onSubmit(values)
                    setSubmitting(false)
                  }}
                  validationSchema={CreateAccountSchema}
                >
                  {({ errors, values, handleChange, handleSubmit }) => (
                    <Form noValidate onSubmit={handleSubmit} className="form-container">
                      <Row>
                        <Form.Group as={Col} xs={6}>
                          <Form.Label>First Name</Form.Label>
                          <Form.Control
                            className="login-ipt"
                            type="text"
                            name="firstName"
                            value={values.firstName || ''}
                            onChange={handleChange}
                            isInvalid={!!errors.firstName}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.firstName}
                          </Form.Control.Feedback>
                        </Form.Group>
                        <Form.Group as={Col} xs={6}>
                          <Form.Label>Last Name</Form.Label>
                          <Form.Control
                            className="login-ipt"
                            type="text"
                            name="lastName"
                            value={values.lastName || ''}
                            onChange={handleChange}
                            isInvalid={!!errors.lastName}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.lastName}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} xs={12}>
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            size="lg"
                            className="login-ipt"
                            type="text"
                            name="email"
                            value={values.email || ''}
                            onChange={handleChange}
                            isInvalid={!!errors.email}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.email}
                          </Form.Control.Feedback>
                          {errorMessage}
                        </Form.Group>
                      </Row>
                      {warningMessage}
                      {emailSent===false?(
                        <Button type="submit" id="login-btn" className="submit-btn">Send Login Info</Button>
                      ):(
                        <div></div>
                      )}
                    </Form>
                  )}
                </Formik>
              ):(
                <div></div>
              )}
            </>
          )
        }
        <div className="login-forgot-pwd-container">
          <Link to="/login" onClick={onBack} className="login-forgot-pwd">Back to Login</Link>
        </div>
      </Card.Body>
    </Card>
  )
}
export default CreateAccount